import { create } from 'zustand'
import type { Survey } from '@vc/views/panels/SurveysPanel'

type SurveyDraft = Omit<Survey, 'id' | 'createdAt' | 'isActive' | 'responses'>

type MeetingSurveysState = {
  surveys: Survey[]
  addSurvey: (survey: Survey) => void
  removeSurvey: (surveyId: string) => void
  updateSurvey: (surveyId: string, updates: Partial<Survey>) => void
  createSurvey: (draft: SurveyDraft) => void
}

export const useMeetingSurveysStore = create<MeetingSurveysState>((set) => ({
  surveys: [],
  addSurvey: (survey) => set((s) => ({ surveys: [...s.surveys, survey] })),
  removeSurvey: (surveyId) =>
    set((s) => ({ surveys: s.surveys.filter((survey) => survey.id !== surveyId) })),
  updateSurvey: (surveyId, updates) =>
    set((s) => ({
      surveys: s.surveys.map((survey) =>
        survey.id === surveyId ? { ...survey, ...updates } : survey,
      ),
    })),
  createSurvey: (draft) => {
    const next: Survey = {
      ...draft,
      id: `survey-${Date.now()}-${Math.random().toString(16).slice(2)}`,
      createdAt: Date.now(),
      isActive: true,
      responses: [],
    }
    set((s) => ({ surveys: [...s.surveys, next] }))
  },
}))
